import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { SectionLayoutMetadataBase } from '../../../common-shared-module/model/dyn-form/form-metadata/layout/section-layout.model';
import { ExtendedProcedureForm } from '../../../common-shared-module/model/procedure/extended-procedure-form.model';
import { SectionHistoryService } from '../../services/history/section-history.service';

@Component({
    selector: 'app-form-editor-section-header',
    templateUrl: './form-editor-section-header.component.html',
    styleUrl: './form-editor-section-header.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        MatToolbarModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule
    ]
})
export class FormEditorSectionHeaderComponent {

    @ViewChild("selector", { read: ElementRef }) selectorElementRef!: ElementRef

    @Input({ required: true }) loaded!: Signal<boolean>
    @Input({ required: true }) loadingHttp!: Signal<boolean>
    @Input({ required: true }) procedureForm!: ExtendedProcedureForm

    @Output() restoreState: EventEmitter<SectionLayoutMetadataBase> = new EventEmitter()
    @Output() showPreview: EventEmitter<void> = new EventEmitter()
    @Output() showSectionSelector: EventEmitter<ElementRef> = new EventEmitter()


    constructor(public sectionHistoryService: SectionHistoryService, private readonly changeDetectorRef: ChangeDetectorRef) { }


    unDo(): void {
        let oldSection: SectionLayoutMetadataBase | null = this.sectionHistoryService.unDo()
        if (oldSection == null) {
            return
        }

        this.restoreState.emit(oldSection)
    }

    reDo(): void {
        let oldSection: SectionLayoutMetadataBase | null = this.sectionHistoryService.reDo()
        if (oldSection == null) {
            return
        }

        this.restoreState.emit(oldSection)
    }

    showCurrentSection(): boolean {
        return this.sectionHistoryService.currentHistoryChange != null && this.sectionHistoryService.currentHistoryChange.sectionForm() != null
    }

    refresh() {
        this.changeDetectorRef.detectChanges()
    }

}
